import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faChevronRight, faChevronLeft, faChevronCircleDown, faChevronCircleUp, faAmbulance, faHospital, faBell, faEye, } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter, faYoutube, faPinterestP, faTumblr, faInstagram,  } from '@fortawesome/free-brands-svg-icons'
import { faCopyright, } from '@fortawesome/free-regular-svg-icons'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import './assets/css/ressets-style.css'
import VueCryptojs from 'vue-cryptojs'




import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faBars, faChevronRight, faChevronLeft, faChevronCircleDown, faChevronCircleUp, faCopyright, faAmbulance, faHospital, faBell, faEye, faFacebookF, faTwitter, faYoutube, faPinterestP, faTumblr, faInstagram)

Vue.component('loading-spinner', Loading)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)


Vue.use(VueCryptojs)


Vue.config.productionTip = false

new Vue({
  router,
  store,

  render: h => h(App),
}).$mount('#app-scc')
